module.exports = __webpack_public_path__ + "img/claire-pro.a433b8e8.jpg";